export default __webpack_public_path__ + "static/media/IMG_0539.6eeb26ee.jpg";